module.exports = __webpack_public_path__ + "img/faq.d46f0847.png";